module.exports = __webpack_public_path__ + "static/media/Organization_0.2f001b6a.svg";